import { FormFieldWidget, FormTextFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import CSVTextArea from './CSVTextArea.vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.Text,
    widget: 'CSVTextArea',
    multi: false
  })
)
export class FormTextCSVTextAreaFieldWidget extends FormTextFieldWidget {
  public initialize(props) {
    super.initialize(props);
    // this.setComponent(CSVTextArea);
    return this;
  }

  public change(value) {
    const csv = value?.replaceAll(/[ \t\n]/g, ',') ?? value;
    super.change(csv);
  }
}
